export enum EWhiteLabelingClient {
    MINDSHIELD = 'mindshield',
    RIDLEY_CONSULTING = 'ridleyconsulting',
};

export enum EProduct {
    MBTS = 'mbts',
    MCSA = 'mcsa',
};